import React from 'react';
import { ToastContainer } from 'react-toastify';
import defaultOptions from './defaultOptions';

const NotificationProvider = (props) => {
  return <ToastContainer {...defaultOptions} {...props} />;
};

export default NotificationProvider;
